var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_911527704"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M200 10l-197 0c-2,0 -3,1 -3,3l0 177c0,2 1,3 3,3l197 0c2,0 3,-1 3,-3l0 -34c0,-2 -1,-4 -3,-4 -2,0 -3,2 -3,4l0 31 -191 0 0 -145 191 0 0 101c0,1 1,3 3,3 2,0 3,-2 3,-3l0 -130c0,-2 -1,-3 -3,-3l0 0zm-194 6l120 0 0 20 -120 0 0 -20zm127 20l0 -20 64 0 0 20 -64 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M165 22c-2,0 -4,2 -4,4 0,2 2,3 4,3 2,0 3,-1 3,-3 0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M147 22c-2,0 -3,2 -3,4 0,2 1,3 3,3 2,0 4,-1 4,-3 0,-2 -2,-4 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M183 22c-2,0 -4,2 -4,4 0,2 2,3 4,3 2,0 3,-1 3,-3 0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M137 88c-1,1 -1,3 0,4 1,2 3,2 4,1 12,-9 19,-22 19,-37 0,-2 -2,-3 -4,-3l-84 0c0,0 0,0 0,0l-25 0c-2,0 -4,1 -4,3 0,20 13,38 32,44 3,11 12,19 23,21l0 17 -23 0c-2,0 -3,1 -3,3l0 32c0,2 1,3 3,3l53 0c2,0 4,-1 4,-3l0 -32c0,-2 -2,-3 -4,-3l-23 0 0 -17c12,-2 22,-11 24,-23l5 -39 19 0c-1,12 -6,22 -16,29zm-12 82l-47 0 0 -26 47 0 0 26zm-75 -111l19 0 5 33c-13,-5 -23,-18 -24,-33l0 0zm72 38c-1,10 -10,18 -20,18 -11,0 -20,-8 -21,-18l-5 -38 6 0 2 11c0,1 2,3 3,3 0,0 0,0 1,0 1,-1 3,-2 2,-4l-1 -10 38 0 -5 38 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M88 79c-1,0 -3,2 -2,4l1 13c1,7 8,12 15,12 1,0 3,-1 3,-3 0,-2 -2,-3 -3,-3 -4,0 -8,-3 -8,-7l-2 -13c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M87 157c0,2 2,3 4,3l22 0c1,0 3,-1 3,-3 0,-2 -2,-4 -3,-4l-22 0c-2,0 -4,2 -4,4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.68e8d0c4c36b54a0e6ea4e9f3fab65fc.svg";
export { ForwardRef as ReactComponent };